import classNames from 'classnames'

import './CharacterCounter.scss'

export type CharacterCounterProps = {
  count: number
  maxLength: number
  isOverLimit?: boolean
}

export const CharacterCounter: React.FC<CharacterCounterProps> = ({
  count,
  maxLength,
  isOverLimit = false,
}) => {
  return (
    <span
      className={classNames('character-counter', { 'over-limit': isOverLimit })}
    >
      {count}/{maxLength}
    </span>
  )
}
